import { useEffect, useState } from 'react';
import { supabase } from '../../shared/supabase/supabaseClient';
import type { ComboComponentPickOption } from '../components/ComboComponentsEditor';

/** Productos elegibles como partes de un combo (misma query que el wizard). */
export function useComboProductPickOptions(enabled: boolean, organizationId: string | null) {
  const [options, setOptions] = useState<ComboComponentPickOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !organizationId?.trim()) {
      setOptions([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    void (async () => {
      try {
        const { data, error } = await supabase
          .from('products')
          .select('id, name, sku, barcode')
          .eq('organization_id', organizationId)
          .eq('is_active', true)
          .or('is_misc.is.null,is_misc.eq.false')
          .is('deleted_at', null)
          .order('name')
          .limit(500);
        if (error) throw error;
        if (!cancelled) {
          setOptions((data ?? []) as ComboComponentPickOption[]);
        }
      } catch {
        if (!cancelled) setOptions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled, organizationId]);

  return { options, loading };
}
